import { render } from "./checkboard.vue?vue&type=template&id=6e1e9e4e"
import script from "./checkboard.vue?vue&type=script&lang=js"
export * from "./checkboard.vue?vue&type=script&lang=js"

import "./checkboard.vue?vue&type=style&index=0&id=6e1e9e4e&lang=css"
script.render = render

export default script